import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../constants';

export const useStyles = makeStyles(() => ({
  root: {
    width: 280,
    maxHeight: '100%',
    background: COLORS.white,
    borderRight: `1px solid ${COLORS.border}`,
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    overflow: 'hidden',
  },
  sidebarHeader: {
    padding: 12,
    borderBottom: `1px solid ${COLORS.border}`,
    flexShrink: 0,
  },
  sidebarTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: COLORS.body,
    marginBottom: 6,
  },
  treeContainer: {
    flex: 1,
    minHeight: 0,
    overflow: 'auto',
    padding: 12,
  },
}));
